// src/pages/contact/views/Contact.view.tsx
import React from "react";
import Header from "../../../components/header/Header";
import i18n from "../../../i18n/i18n";
import { ContactViewProps } from "../types";
import LazyLoadedSection from "../../../components/lazyloadedsection/LazyLoadedSection.view";

import {
  ContactContainer,
  PageTitle,
  ContactLayout,
  ContactFormContainer,
  ContactInfoContainer,
  InfoCard,
  InfoTitle,
  InfoList,
  InfoItem,
  InfoIcon,
  InfoContent,
  InfoLabel,
  InfoValue,
  SocialMediaContainer,
  SocialMediaList,
  SocialMediaLink,
  Form,
  FormGroup,
  FormLabel,
  Input,
  Textarea,
  ErrorMessage,
  SubmitButton,
  SuccessMessage,
  ErrorAlert,
} from "../Contact.styled";

export function ContactView({
  isLoading,
  formData,
  formErrors,
  isSubmitting,
  submitSuccess,
  socialMedia,
  contactInfo,
  handleInputChange,
  handleSubmit,
  resetForm,
}: ContactViewProps) {
  const t = (key: string, defaultValue?: string) =>
    (i18n as any).t(key, defaultValue);
  return (
    <>
      <Header />
      <main>
        <ContactContainer>
          <PageTitle>{t("contact:title", "Contato")}</PageTitle>

          <LazyLoadedSection visible={!isLoading}>
            {/* Introduction removida conforme solicitação */}

            <ContactLayout>
              <ContactFormContainer>
                <InfoTitle>
                  {t("contact:sendMessage", "Envie uma mensagem")}
                </InfoTitle>

                {submitSuccess === true && (
                  <SuccessMessage>
                    <i className="ph ph-check-circle"></i>
                    {t(
                      "contact:success",
                      "Mensagem enviada com sucesso!"
                    )}
                  </SuccessMessage>
                )}

                {submitSuccess === false && (
                  <ErrorAlert>
                    <i className="ph ph-warning"></i>
                    {t(
                      "contact:error",
                      "Ocorreu um erro ao enviar sua mensagem. Tente novamente."
                    )}
                  </ErrorAlert>
                )}

                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <FormLabel htmlFor="name">
                      {t("contact:name", "Nome")}
                    </FormLabel>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder={t(
                        "contact:placeholderName",
                        "Seu nome"
                      )}
                      hasError={!!formErrors.name}
                      disabled={isSubmitting}
                    />
                    {formErrors.name && (
                      <ErrorMessage>{formErrors.name}</ErrorMessage>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <FormLabel htmlFor="email">
                      {t("contact:email", "E-mail")}
                    </FormLabel>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder={t(
                        "contact:placeholderEmail",
                        "seu.email@exemplo.com"
                      )}
                      hasError={!!formErrors.email}
                      disabled={isSubmitting}
                    />
                    {formErrors.email && (
                      <ErrorMessage>{formErrors.email}</ErrorMessage>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <FormLabel htmlFor="subject">
                      {t("contact:subject", "Assunto")}
                    </FormLabel>
                    <Input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      placeholder={t(
                        "contact:placeholderSubject",
                        "Assunto da mensagem"
                      )}
                      hasError={!!formErrors.subject}
                      disabled={isSubmitting}
                    />
                    {formErrors.subject && (
                      <ErrorMessage>{formErrors.subject}</ErrorMessage>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <FormLabel htmlFor="message">
                      {t("contact:message", "Mensagem")}
                    </FormLabel>
                    <Textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder={t(
                        "contact:placeholderMessage",
                        "Escreva sua mensagem aqui..."
                      )}
                      hasError={!!formErrors.message}
                      disabled={isSubmitting}
                    />
                    {formErrors.message && (
                      <ErrorMessage>{formErrors.message}</ErrorMessage>
                    )}
                  </FormGroup>

                  <SubmitButton type="submit" isSubmitting={isSubmitting}>
                    {isSubmitting
                      ? t("contact:sending", "Enviando...")
                      : t("contact:send", "Enviar Mensagem")}
                  </SubmitButton>
                </Form>
              </ContactFormContainer>

              <ContactInfoContainer>
                <InfoCard>
                  <InfoTitle>
                    {t("contact:contactInfo", "Informações de Contato")}
                  </InfoTitle>
                  <InfoList>
                    <InfoItem>
                      <InfoIcon>
                        <i className="ph ph-envelope"></i>
                      </InfoIcon>
                      <InfoContent>
                        <InfoLabel>{t("contact:email", "E-mail")}</InfoLabel>
                        <InfoValue>{contactInfo.email}</InfoValue>
                      </InfoContent>
                    </InfoItem>

                    {/* Telefone removido conforme solicitação */}

                    <InfoItem>
                      <InfoIcon>
                        <i className="ph ph-map-pin"></i>
                      </InfoIcon>
                      <InfoContent>
                        <InfoLabel>
                          {t("contact:location", "Localização")}
                        </InfoLabel>
                        <InfoValue>{contactInfo.location}</InfoValue>
                      </InfoContent>
                    </InfoItem>

                    {/* Disponibilidade removida conforme solicitação */}
                  </InfoList>

                  <SocialMediaContainer>
                    <InfoLabel>
                      {t("contact:socialNetworks", "Redes Sociais")}
                    </InfoLabel>
                    <SocialMediaList>
                      {socialMedia.map(social => (
                        <SocialMediaLink
                          key={social.id}
                          href={social.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={t(
                            `common:social.${social.name.toLowerCase()}`,
                            social.name
                          )}
                        >
                          <i className={`ph ${social.icon}`}></i>
                        </SocialMediaLink>
                      ))}
                    </SocialMediaList>
                  </SocialMediaContainer>
                </InfoCard>
              </ContactInfoContainer>
            </ContactLayout>

            {/* Mapa removido conforme solicitação */}
          </LazyLoadedSection>
        </ContactContainer>
      </main>
    </>
  );
}

export default ContactView;
